module.exports = __webpack_public_path__ + "static/header-background_600.4e64a9cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-background_600.png
// module id = 1250
// module chunks = 35783957827783